import { useEffect } from "react";
import { menuCmsHeaderBodyClass } from "../common/helpers/common-conts.js";
const useMenuCmsHeaderHook = ({
  isMenuCms,
  newTopMenu,
  menuMainCmsHeaderEnabled,
  menuMainCmsTopEnabled,
  menuMainCmsBottomEnabled,
  country,
  getMenu
}) => {
  useEffect(() => {
    if (getMenu && (newTopMenu || menuMainCmsHeaderEnabled || menuMainCmsTopEnabled || menuMainCmsBottomEnabled) && country) {
      getMenu({
        country
      });
    }
  }, [getMenu, newTopMenu, menuMainCmsHeaderEnabled, menuMainCmsTopEnabled, menuMainCmsBottomEnabled, country]);
  useEffect(() => {
    if (isMenuCms && menuMainCmsHeaderEnabled) {
      document.body.classList.add(menuCmsHeaderBodyClass);
    }
    return () => {
      document.body.classList.remove(menuCmsHeaderBodyClass);
    };
  }, [isMenuCms, menuMainCmsHeaderEnabled]);
};
export {
  useMenuCmsHeaderHook
};
